import { useState, useCallback, useEffect, useMemo } from "react";

export default function useMore<T>(items: T[], chunkSize: number) {
  const [itemsToShow, setItemsToShow] = useState<T[]>([]);
  const [currentPosition, setCurrentPosition] = useState(chunkSize);
  const [focusElementIndex, setFocusElementIndex] = useState<number | null>(
    null
  );

  const hasMore = useMemo(
    () => !!items.slice(currentPosition).length,
    [items, currentPosition]
  );

  useEffect(() => {
    if (!itemsToShow.length && items.length) {
      setItemsToShow(items.slice(0, chunkSize));
    }
  }, [itemsToShow, items, chunkSize]);

  const loadMore = useCallback(() => {
    setItemsToShow(items.slice(0, currentPosition + chunkSize));
    setFocusElementIndex(currentPosition);
    if (items.slice(currentPosition + chunkSize).length) {
      setCurrentPosition(currentPosition + chunkSize);
    } else {
      setCurrentPosition(items.length);
    }
  }, [items, currentPosition, chunkSize]);

  return {
    itemsToShow,
    hasMore,
    loadMore,
    focusElementIndex,
  };
}
